module.exports = __webpack_public_path__ + "media/images/russia_flag-9471434c5f2ec6bc727e6286d0b8ba76.jpg";